import { _delete, _get, _post, _put } from "lib/rest";
import {
  cardInfoType,
  orderStatusType,
  refundParamType,
  subscriptionType,
} from "lib/store/billing";
import { commonGetType } from "lib/store/common";

/*
 *
 *
 * 카드
 *
 *
 * */

//현재 등록된 카드번호 조회
export const getCard = async () => await _get("/accounts/payments/card/");
//
export const addCard = async (data: cardInfoType) =>
  await _post("/accounts/payments/card/", data);
export const removeCard = async () => await _delete("/accounts/payments/card/");

/*
 *
 *
 * 구독
 *
 *
 * */
//현재 구독상태 조회
export const getSubscription = async () =>
  await _get("/accounts/payments/subscription/");
//구독 시작
export const startSubscription = async (data: subscriptionType) =>
  await _post("/accounts/payments/subscription/", data);
//예약결제 취소 (기구독건유지)
export const deleteSubscription = async (reason: { reason: string }) =>
  await _put("/accounts/payments/subscription/", reason);

/*
 *
 *
 * 환불
 *
 *
 * */
export const refund = async (data: refundParamType) =>
  await _post("/accounts/payments/subscription/cancel/", data);
export const refundReceipts = async () => await _get("/accounts/refund/");
export const getRefundReceipt = async (order: number) =>
  await _get(`/accounts/refund/${order}/`);

/*
 *
 *
 * 주문내역
 *
 *
 * */
export const orderReceipt = async (param?: orderStatusType & commonGetType) =>
  await _get("/accounts/order/", param);
